<!------------------------------------------------------------------------------
  - Copyright (c) 2024. dnote.ai
  -
  - @project DNOTE.AI-Frontend
  - @author dnote.ai
  - @copyright Dnote.ai All rights reserved
  ----------------------------------------------------------------------------->

<template>
    <DashboardContainer :style="'px-0 mx-0'"
                         @refresh="refreshPage"
                        :refresh-button="true">
        <DashboardCard header-title="List"
                       column="w-100">
            <div class="d-block position-relative p-0 m-0">

                <!-- Search Box -->
        <div class="row mb-3">
            <div class="col-md-6">
                <InputText
                    v-model="searchText"
                    placeholder="Search Template"
                    class="w-100"/>
            </div>
        </div>


        <!-- added date is 06/06/2026 -->

        
    <!-- Type Filter -->
    <div class="mb-3">
        <Button
            label="ALL"
            @click="selectedType='ALL'"
            class="me-2"/>

        <Button
            label="SMS"
            @click="selectedType='SMS'"
            class="me-2"/>

        <Button
            label="EMAIL"
            @click="selectedType='EMAIL'"
            class="me-2"/>

        <Button
            label="WHATSAPP"
            @click="selectedType='WHATSAPP'"/>
    </div>


                <!-- commanda date is 06/06/2026 -->
                <!--  
                <div class="row p-3"
                     :class="index%2!==0 ? 'bg-white' : 'bg-light'"
                     v-for="(singleTemplate, index) in templates"
                     :key="index">
                         -->

                         <!-- added date is 06/06/2026 -->
<div class="row p-3 mb-3 border rounded shadow-sm"
     :class="index%2!==0 ? 'bg-white' : 'bg-light'"
   v-for="(singleTemplate, index) in paginatedTemplates"
     :key="index">

                    <div class="col-12 p-2 fw-bolder">
                        <!--   command date is 06/06/2026
                        <h4 class="fw-bolder">{{ singleTemplate.name }}</h4>
                          -->

                             <!-- added date  is 08/06/2026 -->
                          <h5 class="fw-bolder text-primary mb-2">
    {{ singleTemplate.name }}
</h5>

<div class="mb-2">
    <span class="badge bg-dark me-2">
        {{ singleTemplate.templateStyle }}
    </span>

    <span
        v-if="singleTemplate.active"
        class="badge bg-success">
        ACTIVE
    </span>
</div>



<div class="mb-2">

    <span v-if="singleTemplate.smsText"
          class="badge bg-primary me-2">
        SMS
    </span>

    <span v-if="singleTemplate.emailText"
          class="badge bg-success me-2">
        EMAIL
    </span>

    <span v-if="singleTemplate.whatsappTemplate"
          class="badge bg-warning text-dark">
        WHATSAPP
    </span>

</div>



                    </div>
                    <div class="col-12 p-2 fw-bolder template-text-container"
                         v-if="!isEmpty(singleTemplate.emailText)">
	                    <div v-html="singleTemplate.emailText"/>
                    </div>

                    <!-- command date is 06/06/2026
	                <div class="col-12 p-2"
	                     v-if="!isEmpty(singleTemplate.smsText)">
		                {{ singleTemplate.smsText }}
                    </div>
                     -->

                     <!-- added date is 06/06/2026 -->
                     <div class="col-12 p-2"
     v-if="!isEmpty(singleTemplate.smsText)">
    {{ singleTemplate.smsText.substring(0,100) }}
    <span v-if="singleTemplate.smsText.length > 100">...</span>
</div>

                  <!--  command date is  06/06/2026
	                <div class="col-12 p-2"
	                     v-if="!isEmpty(singleTemplate.whatsappTemplate)">
		                {{ singleTemplate.whatsappTemplate }}
                    </div>
                    -->

                    <!-- added date is 06/06/2026 -->
                    <div class="col-12 p-2"
     v-if="!isEmpty(singleTemplate.whatsappTemplate)">
    {{ singleTemplate.whatsappTemplate.substring(0,100) }}
    <span v-if="singleTemplate.whatsappTemplate.length > 100">...</span>
</div>
                    
                    <div class="col-md-6">
                        <Button label="Update"
                                icon="pi pi-pencil"
                                severity="warn"
                                size="small"
                                @click="updateTemplate(singleTemplate)"
                                outlined
                                class="w-100"/>
                    </div>
                    <div class="col-md-6">
                        <Button label="Delete"
                                icon="pi pi-trash"
                                size="small"
                                @click="removeTemplate(singleTemplate, index)"
                                outlined
                                severity="danger"
                                class="w-100"/>
                    </div>
                </div>

                <div
    v-if="filteredTemplates.length > pageSize"
    class="d-flex justify-content-center mt-3">

    <Button
        label="Previous"
        class="me-2"
        :disabled="currentPage === 1"
        @click="currentPage--"/>

    <span class="mx-3 align-self-center">
        Page {{ currentPage }} of
        {{ Math.ceil(filteredTemplates.length / pageSize) }}
    </span>

    <Button
        label="Next"
        :disabled="
            currentPage >=
            Math.ceil(filteredTemplates.length / pageSize)
        "
        @click="currentPage++"/>

</div>
                
                <div class="d-block position-relative"
                     v-if="filteredTemplates.length===0">
                    <h3 class="my-0 text-danger text-center">No Templates(found)</h3>
                </div>
            </div>
        </DashboardCard>
    </DashboardContainer>
</template>
<script>
import DashboardCard from "@/dashboard/containers/DashboardCard.vue";
import DashboardContainer from "@/dashboard/containers/DashboardContainer.vue";
import Button from "primevue/button";
import {isEmpty} from "@/utils/AppStringUtils";
import InputText from "primevue/inputtext";
export default {
    name: "ListCommunication",
    components: {
        DashboardCard,
        Button,
        DashboardContainer,
          InputText
    },
    emits:["sendTemplate"],
	computed: {
    isInstitutionChurch: function(){
        return this.isChurch;
    },

    filteredTemplates(){
    return this.templates.filter(template => {

        const matchesSearch =
            template.name.toLowerCase()
                .includes(this.searchText.toLowerCase());

        if(this.selectedType === "ALL"){
            return matchesSearch;
        }

      if(this.selectedType === "SMS"){
    return matchesSearch && template.smsText;
}

       if(this.selectedType === "EMAIL"){
    return matchesSearch && template.emailText;
}
if(this.selectedType === "WHATSAPP"){
    return matchesSearch && template.whatsappTemplate;
}

        return matchesSearch;
    });
},

paginatedTemplates(){
    const start =
        (this.currentPage - 1) * this.pageSize;

    return this.filteredTemplates.slice(
        start,
        start + this.pageSize
    );
}
    },

    watch: {
    searchText(){
        this.currentPage = 1;
    },

    selectedType(){
        this.currentPage = 1;
    }
},
    data(){
        return {
            templates : [],
            count  : 0,
            searchText : "",
            selectedType : "ALL",
            currentPage : 1,
        pageSize : 5
        }
    },
    methods:{
	    isEmpty,
        loadTemplates: function(){
            let data = this.$root['addInstitutionId']({});
            this.$api.post("/communication/get/template", data).then(response=>{
                this.templates = response.objects.map(singleTemplate=>{
					return {
						...singleTemplate,
						name: singleTemplate.name.toUpperCase()
					}
                });
            }).catch(error=>{
                this.$root['handleApiError'](error, "Template(s) Loading");
            });
        },
        refreshPage : function(){

    this.searchText = "";
    this.selectedType = "ALL";

    if(this.$root["isInstitutionSet"]()) {
        this.loadTemplates();

        this.$root['showAlert'](
            "success",
            "Refresh",
            "Templates refreshed successfully"
        );
    }
},
        updateTemplate : function(template){
            this.templateData  = {
                ...this.templateData,
                id : template.id,
                institutionId : template.institutionId,
                type :  template.type,
                text  : template.text,
                style : template.style,
            }
			template = {
				...template,
				communicationWays: (template.communicationWays!==null && template.communicationWays.length>0)
					? template.communicationWays[0]
					: null
			};
            this.isEditing = true;
	        this.$emit("sendTemplate", template);
	        let url = this.isInstitutionChurch
		        ? "/church/communication/template/1"
		        : "/organizations/communication/template/1";
	        this.$router.push(url);
        },
        removeTemplate : function(template,  index){
            this.$api.delete("/communication/delete-template/"+template.id).then(response=>{
                this.templates.splice(index ,1);
                this.$root['showAlert']("success", "Deletion", response.message);
            }).catch(error=>{
                this.$root['handleApiError'](error, 'Deletion');
            })
        },
    },
    beforeMount() {
        this.loadTemplates();
    },
	props: {
		isChurch: {
			type: Boolean,
			required: true,
			default(){
				return true;
			}
		}
	},
}
</script>



<style>
	.template-text-container p{
		line-height: normal !important;
		margin-bottom: 0 !important;
	}
</style>